<template>
    <Layout>
        <BookUploadForm />
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { BookUploadForm } from '@speechki-frontend/core/book/components';

export default {
    name: 'UploadPage',
    components: {
        Layout,
        BookUploadForm
    },
    created() {
        if (this.$store.getters.isListener) {
            this.$router.replace('/');
        }
    }
};
</script>
